<section class="iguau-como" aria-labelledby="iguau-como-titulo">
  <span class="iguau-como__nube iguau-como__nube--izquierda" aria-hidden="true"></span>
  <span class="iguau-como__nube iguau-como__nube--derecha" aria-hidden="true"></span>
  <i class="fa-solid fa-paw iguau-como__huella iguau-como__huella--alta" aria-hidden="true"></i>
  <i class="fa-solid fa-paw iguau-como__huella iguau-como__huella--baja" aria-hidden="true"></i>

  <div class="iguau-como__interior">
    <header class="iguau-como__cabecera">
      <h2 id="iguau-como-titulo">
        <span class="iguau-como__rayas" aria-hidden="true"></span>
        ¿Cómo funciona?
        <span class="iguau-como__rayas iguau-como__rayas--derecha" aria-hidden="true"></span>
      </h2>
      <p>En solo 3 pasos, tu mascota ya forma parte de la gran familia iGuau.</p>
    </header>

    <div class="iguau-como__pasos">
      <ng-container *ngFor="let paso of pasos; let ultimo = last; trackBy: trackByNumero">
        <a class="iguau-como__paso" [href]="enlace(paso.url)" [attr.aria-label]="'Paso ' + paso.numero + ': ' + paso.titulo">
          <div class="iguau-como__ilustracion" [ngClass]="'iguau-como__ilustracion--' + paso.tipo">
            <span class="iguau-como__fondo-icono"></span>
            <ng-container [ngSwitch]="paso.tipo">
              <span *ngSwitchCase="'perfil'" class="iguau-como__icono-perfil">
                <i class="fa-regular fa-circle-user" aria-hidden="true"></i>
                <i class="fa-solid fa-paw" aria-hidden="true"></i>
              </span>
              <span *ngSwitchCase="'descubre'" class="iguau-como__tarjetas">
                <span class="iguau-como__tarjeta iguau-como__tarjeta--izq"><i class="fa-solid fa-paw" aria-hidden="true"></i></span>
                <span class="iguau-como__tarjeta iguau-como__tarjeta--centro"><i class="fa-solid fa-dog" aria-hidden="true"></i></span>
                <span class="iguau-como__tarjeta iguau-como__tarjeta--der"><i class="fa-solid fa-heart" aria-hidden="true"></i></span>
              </span>
              <span *ngSwitchDefault class="iguau-como__icono-muros">
                <i class="fa-regular fa-comments" aria-hidden="true"></i>
                <i class="fa-solid fa-paw" aria-hidden="true"></i>
              </span>
            </ng-container>
            <span class="iguau-como__numero">{{ paso.numero }}</span>
          </div>
          <h3>{{ paso.titulo }}</h3>
          <p>{{ paso.descripcion }}</p>
          <span class="iguau-como__visitar">Descubrir <i class="fa-solid fa-arrow-right" aria-hidden="true"></i></span>
        </a>
        <div class="iguau-como__conector" *ngIf="!ultimo" aria-hidden="true">
          <svg viewBox="0 0 70 20" fill="none"><path d="M2 5C18 17 40 16 61 7" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-dasharray="5 5"/><path d="M54 4L63 7L58 14" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
      </ng-container>
    </div>
  </div>
</section>
